/**
 * Auth API Service
 *
 * Chiamate API reali per l'autenticazione.
 * Utilizzato quando VITE_USE_MOCK_DATA=false.
 */

import { httpClient } from '@/api/client';
import { authEndpoints } from '@/api/endpoints';
import type {
  AuthService,
  AuthResponse,
  RefreshTokenResponse,
  LoginRequest,
  ResetPasswordRequest,
  TokenValidationResponse,
  User,
} from '../types/auth.types';

/**
 * Servizio di autenticazione con API reali
 */
export const authApi: AuthService = {
  /**
   * Login utente
   */
  async login(data: LoginRequest): Promise<AuthResponse> {
    return httpClient.post<AuthResponse>(authEndpoints.login(), data);
  },

  /**
   * Valida un token esistente e ritorna i dati utente
   */
  async validateToken(_token: string): Promise<User> {
    // Il token viene inviato automaticamente dall'httpClient tramite header
    return httpClient.get<User>(authEndpoints.me());
  },

  /**
   * Rinnova i token usando il refresh token
   */
  async refreshToken(refreshToken: string): Promise<RefreshTokenResponse> {
    return httpClient.post<RefreshTokenResponse>(authEndpoints.refresh(), {
      refreshToken,
    });
  },

  /**
   * Richiedi email per reset password
   */
  async forgotPassword(email: string): Promise<void> {
    await httpClient.post(authEndpoints.forgotPassword(), { email });
  },

  /**
   * Verifica validità di un token di reset password
   */
  async verifyResetToken(token: string): Promise<TokenValidationResponse> {
    return httpClient.post<TokenValidationResponse>(
      authEndpoints.verifyResetToken(),
      { token }
    );
  },

  /**
   * Reset password con token
   */
  async resetPassword(data: ResetPasswordRequest): Promise<void> {
    await httpClient.post(authEndpoints.resetPassword(), data);
  },

  /**
   * Logout utente
   */
  async logout(): Promise<void> {
    await httpClient.post(authEndpoints.logout());
  },
};
